<template>
  <div>
    <div class="enquiry-form mt-2 container col-md-6">
      <h3 class="text-primary">Have Any Questions?</h3>
      <CCard>
        <CCardBody>
          <ValidationObserver ref="enquiryForm" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)" name="enquiryForm">
              <CRow>
                <CCol md="12">
                  <CRow class="row mb-3">
                    <label class="required col-lg-12 col-md-12">Name</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <TextInput
                          name="name"
                          @input="handleChangeInput"
                          :value="profile.name"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="12">
                  <CRow class="row mb-3">
                    <label class="required col-lg-12 col-md-12">Email</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <TextInput
                          name="email"
                          @input="handleChangeInput"
                          :value="profile.email"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="12">
                  <CRow class="row mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >Organisation Name</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <TextInput
                          name="organisation_name"
                          @input="handleChangeInput"
                          :value="profile.organisation_name"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="12">
                  <CRow class="row mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >Role/Job Title</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <TextInput
                          name="role_job_title"
                          @input="handleChangeInput"
                          :value="profile.role_job_title"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="12">
                  <CRow class="row mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >Country/Region</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <Select
                          name="country"
                          @input="handleChangeSelect"
                          :value="profile.country"
                          :options="
                            options && options['birth_place']
                              ? options['birth_place']
                              : []
                          "
                          :taggable="false"
                          :multiple="false"
                          :clearable="true"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="12">
                  <CRow class="row mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >Enquiry Details</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <TextareaInput
                          name="enquiry_details"
                          :value="profile.enquiry_details"
                          @input="handleChangeInput"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
              <div class="d-flex">
                <CButton type="submit" color="primary" class="btn-tfw">
                  Enquire Now
                </CButton>
                <CButton
                  type="button"
                  @click="cancel"
                  color="secondary"
                  class="btn-tfw ml-2"
                >
                  Cancel
                </CButton>
              </div>
            </form>
          </ValidationObserver>
        </CCardBody>
      </CCard>
    </div>
    <NewFooter />
  </div>
</template>
<script>
import TextInput from "@/components/reusable/Fields/TextInput";
import Select from "@/components/reusable/Fields/Select.vue";
import TextareaInput from "@/components/reusable/Fields/TextareaInput.vue";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import NewFooter from "../../containers/STM/NewFooter.vue";

export default {
  name: "EnquiryForm",
  components: {
    TextInput,
    Select,
    TextareaInput,
    NewFooter,
  },
  data() {
    return {
      profile: {},
    };
  },
  computed: {
    ...mapGetters(["locationCountryInfo"]),
    options() {
      return {
        birth_place: this.locationCountryInfo || [],
      };
    },
  },
  methods: {
    ...mapActions(["showToast", "sendEnquiry","scrollToTop", "hideLoader"]),
    cancel() {
      this.$router.push({ path: "/tfm" });
    },
    handleChangeInput(name, value) {
      Vue.set(this.profile, name, value);
    },
    handleChangeSelect(name, value) {
      Vue.set(this.profile, name, value);
    },
    async onSubmit() {
      const isValid = await this.$refs.enquiryForm.validate();
      if (!isValid) {
        return this.showToast({
          class: "bg-danger text-white",
          message: "Please fill all mandatory fields!",
        });
      }

      const body = `<html>
       <h2 style='color:#2c3e50;'>New Customer Enquiry</h2>
       <p><b>Name:</b> ${this.profile.name}</p>
       <p><b>Email:</b> ${this.profile.email}</p>
       <p><b>Organisation:</b> ${this.profile.organisation_name}</p>
       <p><b>Country:</b> ${this.profile.country?.label}</p>
       <p><b>Role/Job Title:</b> ${this.profile.role_job_title}</p>
       <p><b>Message:</b> ${this.profile.enquiry_details}</p>
       <hr>
       </html>
       `;
      const payload = {
        email_to: "support@talentfind.com",
        subject: "Enquiry from TalentFind Website",
        body,
      };
      this.sendEnquiry(payload).then(() => {
        setTimeout(() => {
            this.hideLoader()
          this.$router.push({ path: "/tfm" });
        }, 2000);
      });
    },
  },
  mounted() {
    this.scrollToTop();
    this.$store.dispatch("locationCountryInfo");
  },
};
</script>
<style lang="scss" scoped></style>
